import React, { createContext, useContext, useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const PrevLocationContext = createContext()

export const usePrevLocation = () => useContext(PrevLocationContext)

export const PrevLocationProvider = ({ children }) => {
  const location = useLocation()
  const prevLocationRef = useRef()

  useEffect(() => {
    // Store the current location as the previous location for the next render.
    prevLocationRef.current = location.pathname
  }, [location])

  // To make this work correctly, we need a component that sits inside the Router
  // So we will wrap the children of the provider with a component that has access to the location.
  const value = { prevLocation: prevLocationRef.current }

  return (
    <PrevLocationContext.Provider value={value}>
      {children}
    </PrevLocationContext.Provider>
  )
}
